export default "__VITE_ASSET__C9qqg0za__"